import React, { Component, cloneElement, useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import {
  List,
  Edit,
  Create,
  SimpleForm,
  Toolbar,
  SaveButton,
  TextInput,
  email,
  regex,
  choices,
  required,
  minLength,
  maxLength,
  CreateButton,
  SelectInput,
  Datagrid,
  TextField,
  EditButton,
  DateField,
  Filter,
  RefreshButton,
  TopToolbar,
  ExportButton,
  Pagination,
  useRecordContext,
  useTranslate,
  useResourceContext,
  useRedirect,
} from "react-admin";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  GetCurrentUserRoles,
} from "../common/common";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const validateName = [
  required(),
  minLength(2),
  maxLength(50),
  regex(/^(?=.{1,50}$)[a-z]+(?:[a-z]+)*$/, "Must be a valid name"),
];
const validateEmail = [
  required(),
  email(),
  maxLength(50),
  regex(/([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3})/, "Must be a valid email"),
];
const validateRole = [
  required(),
  choices(
    ["2", "3", "4"],
    "Must be Customer Service , Country admin or Country Super admin"
  ),
];
const validateUAERole = [
  required(),
  choices(["2", "3", "6", "7"], "Please select a valid role"),
];

const StatusField = ({ source }) => {
  const record = useRecordContext();
  return <span>{record[source] ? "Active" : "Inactive"}</span>;
};

const CreateRelatedSdoButton = () => {
  const record = useRecordContext();
  const translate = useTranslate();
  return (
    <Button
      component={Link}
      to={{
        pathname: "/change_log",
        search: `?filter={"id": ${record?.id}}`,
      }}
      // to={{
      //   pathname: `/change_log?filter={"id": ${record?.id}}`,
      // }}
    >
      <div>
        <p className="view-button">
          {translate("resources.whitelist_users.fields.view")}
        </p>
      </div>
    </Button>
  );
};
const Sample = () => {
  const translate = useTranslate();

  return (
    <div>
      <TextInput
        className="create-user-large-textfield"
        source="email"
        validate={validateEmail}
      />
      <div className="valid-emailid">
        {translate("resources.whitelist_users.fields.enter_email")}{" "}
      </div>
    </div>
  );
};

const selectInputStyle = {
  width: 200,
};

const PostFilter = (props) => (
  <Filter {...props}>
    <TextInput
      // label="Search by email.."
      source="email"
    />
    <TextInput
      // label="Search by name.."
      source="username"
    />
    <SelectInput
      style={selectInputStyle}
      source="status"
      // label="Search by status.."
      choices={[
        { id: true, name: "Active" },
        { id: false, name: "Inactive" },
      ]}
    />
  </Filter>
);

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const CreateToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
};
const UserName = ({ record }) => {
  return <span>{record?.username ? `${record?.username}` : "-"}</span>;
};

const topToolbarStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = React.useState(false);
  const [modalMsg, setModalMsg] = React.useState("");
  const [customFilterUrl, setCustomFilterUrl] = React.useState(
    location.search
  );

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location?.pathname?.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    } else {
      setCustomFilterUrl(
        location.search
      );
      fetch(
        `${apiUrl}/${resource}_csv?${location.search}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    }
  };

  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };

  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <CreateButton basePath={basePath} />
        <RefreshButton />
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </>
  );
};

const WhiteListUsersPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
);

export const WhiteListUsersList = (props) => {
  return (
    <>
      <Scrollbars className="scroll-container">
        <List
          {...props}
          exporter={props.exporter}
          pagination={<WhiteListUsersPagination />}
          sort={{ field: "created_at", order: "DESC" }}
          actions={<ListActions permissions={props} />}
          filters={<PostFilter />}
        >
          <Datagrid bulkActionButtons={false}>
            <TextField source="username" />
            {/* <UserName source="username" /> */}
            <TextField source="email" />
            <TextField source="role_description" />
            <StatusField source="status" />
            <DateField
              // label="Access Created At"
              source="created_at"
              showTime
            />
            <CreateRelatedSdoButton source="updated_log" />
            <EditButton source="edit" />
            {/* <DeleteButton  label="Delete" /> */}
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
    </>
  );
};

const opcoDetails = getLocalStorageKey("opco");
const opco_id = opcoDetails && opcoDetails.id;
const postDefaultValue = { opco_id: opco_id };
const EditRedirect = (_basePath, _id, data) => `/whitelist_users`;

export const WhiteListUsersCreate = (props) => {
  const roleData = GetCurrentUserRoles();
  console.log("roleData", roleData);
  const is_uae_csa = roleData ? roleData.indexOf("$csa") > -1 : false;
  console.log("is_uae_csa", is_uae_csa);
  const redirect = useRedirect();
  const translate = useTranslate();

  const onSuccess = () => {
    redirect(`/whitelist_users`);
  };

  return (
    <Create mutationOptions={{ onSuccess }} {...props}>
      <SimpleForm defaultValue={postDefaultValue} toolbar={<CreateToolbar />}>
        <Sample />
        <SelectInput
          className="create-user-large-textfield"
          source="role_id"
          choices={[
            {
              id: "3",
              name: translate(
                "resources.whitelist_users.fields.customer_service"
              ),
            },
            {
              id: "2",
              name: translate("resources.whitelist_users.fields.country_admin"),
            },
            {
              id: "4",
              name: translate(
                "resources.whitelist_users.fields.country_super_admin"
              ),
            },
          ]}
          validate={validateRole}
        />
      </SimpleForm>
    </Create>
  );
};

export const WhiteListUsersEdit = (props) => {
  const roleData = GetCurrentUserRoles();
  const translate = useTranslate();
  console.log("roleData", roleData);
  const is_uae_csa = roleData ? roleData.indexOf("$csa") > -1 : false;
  console.log("is_uae_csa", is_uae_csa, opco_id);
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput
          className="edit-user-large-textfield"
          source="email"
          validate={validateEmail}
        />
        {opco_id !== 13 && (
          <SelectInput
            className="edit-user-large-textfield"
            source="role_id"
            choices={[
              {
                id: "3",
                name: translate(
                  "resources.whitelist_users.fields.customer_service"
                ),
              },
              {
                id: "2",
                name: translate(
                  "resources.whitelist_users.fields.country_admin"
                ),
              },
              {
                id: "4",
                name: translate(
                  "resources.whitelist_users.fields.country_super_admin"
                ),
              },
            ]}
            defaultValue="role_id"
          />
        )}
        {opco_id === 13 && is_uae_csa && (
          <SelectInput
            className="edit-user-large-textfield"
            source="role_description"
            choices={[
              {
                id: "2",
                name: translate(
                  "resources.whitelist_users.fields.country_admin"
                ),
              },
              {
                id: "3",
                name: translate(
                  "resources.whitelist_users.fields.customer_service"
                ),
              },
              {
                id: "6",
                name: translate("resources.whitelist_users.fields.marketing"),
              },
              {
                id: "5",
                name: translate(
                  "resources.whitelist_users.fields.internal_control"
                ),
              },
            ]}
            defaultValue="role_description"
          />
        )}
        <SelectInput
          className="edit-user-large-textfield"
          source="status"
          choices={[
            { id: true, name: "Active" },
            { id: false, name: "Inactive" },
          ]}
          defaultValue="status"
        />
      </SimpleForm>
    </Edit>
  );
};
